import { render, staticRenderFns } from "./TrackingSheet.vue?vue&type=template&id=22d9d537&"
import script from "./TrackingSheet.vue?vue&type=script&lang=js&"
export * from "./TrackingSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d9d537')) {
      api.createRecord('22d9d537', component.options)
    } else {
      api.reload('22d9d537', component.options)
    }
    module.hot.accept("./TrackingSheet.vue?vue&type=template&id=22d9d537&", function () {
      api.rerender('22d9d537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/TrackingSheet.vue"
export default component.exports